import Vue from 'vue';
export const EmptyShoppingCartIcon = Vue.extend({
    functional: true,
    name: 'EmptyShoppingCartIcon',
    render(createElement, ctx) {
        return (<svg viewBox="0 0 50 50">
                <rect width="50" height="50"/>
                <path 
        // tslint:disable-next-line: max-line-length
        d="M24.26,26.56v9.5l-8.17-3.4V27.25l6,2.49Zm1.49,0,2.19,3.18,6-2.49v5.41l-8.16,3.4ZM13.28,24.45l2.34-3.38,8.24,3.44-2.34,3.38Zm12.86.06,8.24-3.44,2.34,3.38-8.24,3.44ZM14.77,19.67,11,25.13l3.6,1.5v7L25,38l10.4-4.33v-7l3.6-1.5-4-5.79-3.49-1.72-1.37,1L33,20l-8,3.33L17,20l2.84-1.4-1.36-1ZM26.63,12v5h1.64L24.9,19.75,21.54,17h1.64V12H21.81v3.59h-4.1l7.19,5.95,7.2-5.95H28V12Z"/>
            </svg>);
    },
});
//# sourceMappingURL=EmptyShoppingCartIcon.jsx.map